import utils from './../../utils';
import fetch from './../fetch';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}
const inspectType= [
    {
        code: '1',
        label: '前期检查'
    },
    {
        code: '3',
        label: '中期检查'
    },
    {
        code: '5',
        label: '答辩前检查'
    },
    {
        code: '7',
        label: '答辩检查'
    },
    {
        code: '9',
        label: '综合检查'
    },
    {
        code: '11',
        label: '校优'
    },
    {
        code: '13',
        label: '省优'
    },
    {
        code: '15',
        label: '省抽检'
    },
    
]
/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection = () => {
    return DataGrid.selections;
}

const prefixUrl = 'teacher/teaching/quality/thesis/earlier';

const columns = utils.columns([
    {
        key: '$index',
        label: '序号',
        width: 75
    },
    {
        key: 'studentNo',
        label: '学号',
        width: 75
    },
    {
        key: 'studentName',
        label: '学生姓名',
        width: 75
    }, {
        key: 'orgName',
        label: '学生所属部门',
        width: 100
    }, {
        key: 'title',
        label: '论文题目',
        width: 75
    }, {
        key: 'employeeCode',
        label: '指导教师工号',
        width: 100
    }, {
        key: 'employeeName',
        label: '指导教师姓名',
        width: 100
    }, {
        key: 'inspectType',
        label: '检查类别',
        width: 75
    }, {
        key: 'inspectName',
        label: '检查人姓名',
        width: 75
    }, {
        key: 'inspectResult',
        label: '检查结果',
        width: 75
    }, {
        key: 'termName',
        label: '所属学期',
        width: 75
    }
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post(`${prefixUrl}/query?pageNum=${keywords.pageNum}&pageSize=${keywords.pageSize}&order=${keywords.order || ''}&sort=${keywords.sort || ''}`, keywords)
        .then(res => {
            const data = res.payload.data;
            return Object.assign({
                result: data.dataList,
                selects: data.dataList.map(e => {
                    return {
                        value: e.id,
                        checked: false,
                    }
                }),
                checked: false,
                total: data.total,
                pageIndex: data.pageNum,
                pageSize: data.pageSize,
                notify: ([]).length ? '' : '暂无数据...'
            })
        })
}

const remove = (ids) => {
    return fetch.post(`${prefixUrl}/delete`, ids)
        .then(res => {
            if (res.code === 200) {
                return res.payload.data;
            }
        })
}

const getDataById = (id) => {
    return fetch.get(`${prefixUrl}/get/${id}`)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

const update = (domain) => {
    return fetch.post(`${prefixUrl}/update`,domain)
    .then(res => {
        if(res.code === 200) {
            DataGrid.selections = [];
            DataGrid.refresh();
            return res;
        }
    })
}

const queryByStudentName = (params) => {
    return fetch.get(`student/query/by/studentName?studentName=${params.studentName || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if(res.code === 200){
            return res.payload.data;
        }
    })
}

const queryByEmployeeName = (params) => {
    return fetch.get(`employee/query/by/employeeName?employeeName=${params.employeeName || ''}&limit=${params.limit || undefined}`)
    .then(res => {
        if(res.code === 200){
            return res.payload.data;
        }
    })
}

export default {
    inspectType,
    queryByEmployeeName,
    queryByStudentName,
    update,
    getDataById,
    onSelect,
    setRefresh,
    getSelection,
    columns,
    querySearch,
    remove
}